/**
 * The port-forwarded static selects never read a descriptor `Entity`, in one place so the Edit and the
 * Read/Print stacks cannot disagree.
 *
 * `Option`, `Select2` and `Select2Multiple` render through the Picker broker (Edit) and `PickerDisplay`
 * (Read/Print), both of which treat a truthy `PictForm.Entity` as a remote entity search. The legacy select
 * providers ignored that key, so manifests carry stray values (`"Entity": "1"` beside a static
 * `SelectOptions`) that would otherwise empty the list and print raw codes. An explicit `Picker` keeps its
 * Entity: that is the entity opt-in.
 */

/** InputTypes whose descriptor `Entity` this module drops. */
const STATIC_SELECT_INPUT_TYPES = [ 'Option', 'Select2', 'Select2Multiple' ];

/**
 * Remove a stray `Entity` from a static-select descriptor. Leaves every other InputType untouched.
 *
 * @param {Record<string, any>} pPictForm - The form input descriptor's PictForm.
 * @return {boolean} - True when the descriptor is a static select.
 */
function dropStaticSelectEntity(pPictForm)
{
	if (!pPictForm || STATIC_SELECT_INPUT_TYPES.indexOf(pPictForm.InputType) < 0)
	{
		return false;
	}
	if ('Entity' in pPictForm)
	{
		delete pPictForm.Entity;
	}
	return true;
}

module.exports = { STATIC_SELECT_INPUT_TYPES, dropStaticSelectEntity };
